export default __webpack_public_path__ + "40de3b9194676801f4fd87942e0e2c0c.mp3";